import { TrialAndStackStartStackRef } from 'utils/api';
import { GRAFANA_NET_DOMAIN } from 'utils/consts';

export const getStackInstanceUrl = (stack: TrialAndStackStartStackRef): string =>
  stack.url ?? `https://${stack.slug}.${GRAFANA_NET_DOMAIN}`;

export const isStackReadyFromStart = (stack: TrialAndStackStartStackRef): boolean => stack.ready === true;
